// AKM POC §6.4 — kıdeme eklenecek önceki hizmet (gün). Çalışan formu, listesi ve kartı aynı
// dönüşümü kullanır: TextInput sayıyı string verir; boş string int? alana gönderilirse
// System.Text.Json tüm gövdeyi reddeder.
export const toPriorServiceDays = (raw) => {
  if (raw === '' || raw === null || raw === undefined) return null;
  const n = parseInt(raw, 10);
  return Number.isNaN(n) ? null : n;
};

// Yaklaşık yıl/ay karşılığı (ipucu): yıl = gün/365, ay = (gün%365)/30. Sıfır/boş → null (ipucu yok).
export const priorServiceParts = (raw) => {
  const days = toPriorServiceDays(raw);
  if (days === null || days <= 0) return null;
  return { years: Math.floor(days / 365), months: Math.floor((days % 365) / 30) };
};
